import React from 'react';
import { Box, Flex, Grid, GridItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/theme/foundation/colors';

const todayStyle = { backgroundColor: colors.greyScale['100'] };
const selectedStyle = { backgroundColor: colors.primaryScale['600'], color: 'white' };
const defaultStyle = { color: colors.greyScale['500'] };

function CalendarBody({ calendar, getDateProps }) {
  const { weeks } = calendar;

  return (
    <Grid gap={2} templateColumns="repeat(7, 1fr)" templateRows={`repeat(${weeks.length}, 1fr)`}>
      {weeks.map((week, weekIdx) => week.map((dateObj, idx) => {
        const key = `${calendar.month}${calendar.year}${weekIdx}${idx}`;
        if (!dateObj) {
          return (
            <Box key={key} />
          );
        }

        const { date, selected, selectable, today, prevMonth, nextMonth } = dateObj;

        let dayStyle;
        if (today) dayStyle = todayStyle;
        if (selected) dayStyle = selectedStyle;
        if (!selectable || prevMonth || nextMonth) dayStyle = defaultStyle;
        const dateProps = getDateProps({ dateObj });

        return (
          <GridItem key={key} textAlign="center" width="100%">
            <Box
              _disabled={{ cursor: 'not-allowed', bgColor: 'inherit' }}
              _hover={{
                bgColor: 'greyScale.100',
                color: 'primaryScale.600',
                cursor: selectable ? 'pointer' : 'not-allowed'
              }}
              alignItems="center"
              aria-label={dateProps['aria-label']}
              as={Flex}
              borderRadius="round"
              disabled={dateProps.disabled}
              height="40px"
              justify="center"
              style={dayStyle}
              textStyle="bodySm500"
              w="100%"
              onClick={selectable ? dateProps.onClick : () => {}}
            >
              {date.getDate()}
            </Box>
          </GridItem>
        );
      }))}
    </Grid>
  );
}

CalendarBody.propTypes = {
  /* Single month's data */
  calendar: PropTypes.shape({
    /* Zero-based number of month */
    month: PropTypes.number,
    /* Year of month */
    year: PropTypes.number,
    /* Array of an array of date objects for each week of month. Sunday to Saturday */
    weeks: PropTypes.arrayOf(PropTypes.array)
  }),
  /* Function that returns props to apply to date buttons/elements */
  getDateProps: PropTypes.func
};

export default CalendarBody;
